import React from "react";

// FUENTE DE VERDAD DEL AMBIENTE.
// Es lo único que hay que cambiar al publicar:
//   true  → desarrollo: muestra `versionDev` y habilita la bitácora de cambios
//   false → producción: muestra `version` y oculta por completo la bitácora
export const esDesarrollo = false;

export const version = "2.0.8";
export const versionDev = "2.0.29-beta";

function AppVersion({ style = "text-sm" }) {
  return <div className={style}>Versión {esDesarrollo ? versionDev : version}</div>;
}

export default AppVersion;
